import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import { Box, Button, SxProps, Typography, useTheme } from "@mui/material";
import React from "react";

interface ICounterProps {
  onChange: (value: number, id: string) => void;
  initialValue: number;
  minValue?: number;
  maxValue?: number;
  id: string;
}

export default function Counter({
  onChange = () => {},
  initialValue,
  minValue,
  maxValue,
  id,
}: ICounterProps) {
  const theme = useTheme();

  const handleClickIncrement = () => {
    if (maxValue !== undefined && initialValue >= maxValue) {
      return;
    }
    onChange(initialValue + 1, id);
  };

  const handleClickDecrement = () => {
    if (minValue !== undefined && initialValue <= minValue) {
      return;
    }
    onChange(initialValue - 1, id);
  };

  const buttonStyle: SxProps = {
    height: theme.spacing(2.75),
    width: theme.spacing(2.75),
    minHeight: "initial",
    minWidth: "initial",
  };
  return (
    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <Button
        onClick={handleClickDecrement}
        color="primary"
        variant="outlined"
        disabled={minValue !== undefined && initialValue <= minValue}
        sx={{
          p: 0.875,
          ...buttonStyle,
        }}
      >
        <Remove sx={{ fontStyle: "3px" }} />
      </Button>
      <Typography
        sx={{
          minWidth: theme.spacing(4),
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        {initialValue}
      </Typography>
      <Button
        onClick={handleClickIncrement}
        disabled={maxValue !== undefined && initialValue >= maxValue}
        color="primary"
        variant="contained"
        disableElevation
        sx={{
          p: 1,
          ...buttonStyle,
        }}
      >
        <Add fontSize="small" />
      </Button>
    </Box>
  );
}
